<template>
  <div class="standard-page v-flex">
    <b-button-toolbar
      class="button-toolbar"
      aria-label="Toolbar with button groups"
    >
      <b-button><BIcon icon="funnel-fill" /> Filter</b-button>
      <b-button><BIcon icon="box-arrow-up-right" /> Edit</b-button>
    </b-button-toolbar>
    <Table
      class="standard-page-table"
      :fields="tableHeaders"
      :items="merchants"
      :busy="isBusy"
      :totalItems="totalMerchants"
      :totalPages="totalPages"
      :pageSize="pageSize"
      :currentPage="currentPage"
      @pageSizeChanged="handlePageSize"
      @pageChanged="handlePage"
    />
  </div>
</template>

<script>
import Table from '@/components/Table/Table.vue'
// import mockData from './mock-data.js'
import { BIcon } from 'bootstrap-vue'
import endpoints from '@/utils/endpoints.js'
import tableMixins from '@/mixins/TableMixins/tableMixins.js'

export default {
  mixins: [tableMixins],
  components: {
    Table,
    BIcon
  },
  data() {
    return {
      tableHeaders: [
        {
          link: true,
          key: 'name',
          label: 'Business Name'
        },
        {
          key: 'dba_name',
          label: 'Doing Business As'
        },
        'support_email'
      ],
      pageSize: 10,
      currentPage: 1
    }
  },
  mounted() {
    this.getMerchants()
  },
  methods: {
    getMerchants() {
      this.$store.dispatch('getMerchantPage', {
        page: this.currentPage,
        pageSize: this.pageSize
      })
    },
    handlePageSize(pageSize) {
      this.handlePageSizeChange(pageSize)
      this.getMerchants()
    },
    handlePage(newPage) {
      this.handlePageChange(newPage)
      this.getMerchants()
    }
  },
  computed: {
    merchants() {
      return this.$store.getters.merchantPage
    },
    isBusy() {
      return this.$store.getters.isMerchantLoading
    },
    totalMerchants() {
      return this.$store.getters.numMerchants
    },
    totalPages() {
      return Math.ceil(this.totalMerchants / this.pageSize)
    }
  }
}
</script>
